import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import TestCaseView from "../../components/TestCase/testCaseView";
// import TestScenarioGenerator from "../../components/TestScenarioGenerator/TestScenarioGenerator";
import TestScenarioGenerator from "../../components/TestScenarioGenerator/TestScenarioGenerator_old";
import Projects from "../../components/Projects/Projects";
import ReportPortal from "../../components/ReportPortal/ReportPortal";
import ProfilePage from "../../components/profilePage/ProfilePage";
import ModelConfiguration from "../../components/configeration/ModelConfiguration";
import Users from "../../components/admin/users/Users";
import Roles from "../../components/admin/roles/Roles";
import ProjectUsers from "../../components/projectUser/ProjectUsers";
import Organizations from "../../components/admin/organizations/Organizations";
import { Navigate, Route, Routes } from "react-router-dom";
import DEFAULT_ROUTES from "../../constants/routes";
import RestrictedRoute from "../../components/RestrictedRoute";
import RoleEnum from "../../enums/RoleEnum";
import { fetchUserPreferences } from "../../utils/api/userPreference_apis";
import { STATUS } from "../../utils/api/sharedfunction";
import { updateColumnVisibility, updatePageList, updateUserPreferences } from "../../features/userPreference/userPreferenceSlice";
import { viewColumnMap, viewMap } from "../../utils/commonfunctions";
import defaultTestRunColumnVisible from "../../features/userPreference/DefaultFields/testrun.json";
import GhostLoader from "../../components/Loaders/ghostloader";
import TestGroupLibrary from "../../components/TestGroupLibrary/TestGroupLibrary";
import TestGroupDetail from "../../components/TestGroupDetail/TestGroupDetail";
import VariablesAndEnvironment from "../../components/VariablesAndEnvironment";
import ProjectNotificationSettings from "../../components/ProjectNotificationSettings";
import ProjectNotificationPrefsPage from "../../components/ProjectNotificationSettings/ProjectNotificationPrefsPage";
import { PROJECT_NAV_COPY } from "../../components/notifications/notification.constants";
import AssetsManagement from "../../components/AssetsManagement";
import TestLaunchDetail from "../../components/TestLaunchDetail";

import RouteWatcher from "../../utils/RouteWatcher";
import AutomationStudioContainer from "../../components/AutomationStudioNew/AutomationStudioContainer";
import AutomationStudioNewRedirect from "../../components/AutomationStudioNew/AutomationStudioNewRedirect";
import AutomationNew from "../../components/AutomationNew";
import withProjectInfo from "../../components/hoc/withProjectInfo";
import NotFoundContent from "../../components/NotFound/NotFoundContent";
import AICostTracking from "../../components/AICostTracking";
import TrialCreditsBanner from "../../components/TrialCreditsBanner/TrialCreditsBanner";
import SuperAdminCredits from "../../components/admin/superAdminCredits/SuperAdminCredits";
import PlanManagement from "../../components/admin/planManagement/PlanManagement";
import UsageByUser from "../../components/admin/usageByUser/UsageByUser";
import IntegrationApp from "../../components/admin/IntegrationApp";
import UserIntegrationApp from "../../components/UserIntegrationApp";
import FeedbackList from '../../components/FeedbackList';


// Create wrapped component for TestCaseView
const TestCaseViewWithProjectInfo = withProjectInfo(TestCaseView);
const TestGroupLibraryWithProjectInfo = withProjectInfo(TestGroupLibrary);
const VariablesAndEnvironmentWithProjectInfo = withProjectInfo(VariablesAndEnvironment);
const ProjectNotificationSettingsWithProjectInfo = withProjectInfo(ProjectNotificationSettings);
const ProjectNotificationPrefsPageWithProjectInfo = withProjectInfo(ProjectNotificationPrefsPage);
const AssetsManagementWithProjectInfo = withProjectInfo(AssetsManagement);
const TestScenarioGeneratorWithProjectInfo = withProjectInfo(TestScenarioGenerator);
const AutomationStudioWithProjectInfo = withProjectInfo(AutomationStudioContainer);
const AutomationNewWithProjectInfo = withProjectInfo(AutomationNew);
const TestLaunchDetailWithProjectInfo = withProjectInfo(TestLaunchDetail);
const TestGroupDetailWithProjectInfo = withProjectInfo(TestGroupDetail);
const UserIntegrationAppWithProjectInfo = withProjectInfo(UserIntegrationApp);


const routesData = [
  {
    name: "Test Cases",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/test-cases`,
    component: <TestCaseViewWithProjectInfo />,
  },
  {
    name: "AI Generator",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/ai-generator`,
    component: <TestScenarioGeneratorWithProjectInfo />,
  },
  {
    name: "Projects",
    path: DEFAULT_ROUTES.PROJECT.slice(1),
    component: <Projects />,
  },
  {
    name: "Report Portal",
    path: DEFAULT_ROUTES.REPORT_PORTAL.slice(1),
    component: <ReportPortal />,
  },
  {
    name: "Profile",
    path: DEFAULT_ROUTES.PROFILE.slice(1),
    component: <ProfilePage />,
  },
  {
    name: "Variables & Environment",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/variables-and-environment`,
    component: <VariablesAndEnvironmentWithProjectInfo />,
  },
  {
    name: PROJECT_NAV_COPY.projectNotification,
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.PROJECT_NOTIFICATION_PREFS}`,
    component: <ProjectNotificationPrefsPageWithProjectInfo />,
  },
  {
    name: PROJECT_NAV_COPY.projectSettings,
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.PROJECT_SETTINGS}`,
    component: <ProjectNotificationSettingsWithProjectInfo />,
  },
  {
    name: "File Manager",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/file-manager`,
    component: <AssetsManagementWithProjectInfo />,
  },
  {
    name: "Automation Studio",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.AUTOMATION_STUDIO}`,
    component: <AutomationStudioWithProjectInfo />,
  },
  {
    name: "Automation Studio",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.AUTOMATION_STUDIO}/:test_case_id`,
    component: <AutomationStudioWithProjectInfo />,
  },
  {
    name: "Automation Studio (New UI)",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.AUTOMATION_STUDIO_NEW}`,
    component: <AutomationStudioNewRedirect />,
  },
  {
    name: "Automation Studio (New UI)",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.AUTOMATION_STUDIO_NEW}/:test_case_id`,
    component: <AutomationStudioNewRedirect />,
  },
  {
    name: "Automation New",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id${DEFAULT_ROUTES.AUTOMATION_NEW}`,
    component: <AutomationNewWithProjectInfo />,
  },
  {
    name: "Configuration",
    path: DEFAULT_ROUTES.CONFIGURATION.slice(1),
    component: (
      <RestrictedRoute blockedRoles={[RoleEnum.TRIAL_USER.name, RoleEnum.TRIAL_ORG_ADMIN.name, RoleEnum.SUPER_ADMIN.name]}>
        <ModelConfiguration />
      </RestrictedRoute>
    ),
  },
  {
    name: "Users",
    path: DEFAULT_ROUTES.USERS.slice(1),
    component: (
      <RestrictedRoute blockedRoles={[RoleEnum.TRIAL_USER.name]}>
        <Users />
      </RestrictedRoute>
    ),
  },
  {
    name: "Roles",
    path: DEFAULT_ROUTES.ROLES.slice(1),
    component: (
      <RestrictedRoute blockedRoles={[RoleEnum.TRIAL_USER.name, RoleEnum.TRIAL_ORG_ADMIN.name]}>
        <Roles />
      </RestrictedRoute>
    ),
  },
  {
    name: "Project Team",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/users`,
    component: (
      <RestrictedRoute blockedRoles={[RoleEnum.TRIAL_USER.name]}>
        <ProjectUsers />
      </RestrictedRoute>
    ),
  },
  {
    name: "AI Cost Tracking",
    path: DEFAULT_ROUTES.AI_COST_TRACKING.slice(1),
    component: (
      <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
        <AICostTracking />
      </RestrictedRoute>
    ),
  },
  {
    name: "Organizations",
    path: DEFAULT_ROUTES.ORGANIZATIONS.slice(1),
    component: (
      <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
        <Organizations />
      </RestrictedRoute>
    ),
  },
  {
    name: "Credit Management",
    path: DEFAULT_ROUTES.SUPER_ADMIN_CREDITS.slice(1),
    component: (
      <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
        <SuperAdminCredits />
      </RestrictedRoute>
    ),
  },
  {
    name: "Plan Management",
    path: DEFAULT_ROUTES.PLAN_MANAGEMENT.slice(1),
    component: (
      <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
        <PlanManagement />
      </RestrictedRoute>
    ),
  },
  {
    name: "Usage by User",
    path: DEFAULT_ROUTES.USAGE_BY_USER.slice(1),
    component: (
      <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
        <UsageByUser />
      </RestrictedRoute>
    ),
  },
  {
    name: "User Feedback",
    path: DEFAULT_ROUTES.FEEDBACK.slice(1),
    component: (
      <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
        <FeedbackList />
      </RestrictedRoute>
    ),
  },
  {
    name: "Test Groups",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/test-groups`,
    component: <TestGroupLibraryWithProjectInfo />,
  },
  {
    name: "Test Group Detail",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/test-groups/:group_id`,
    component: <TestGroupDetailWithProjectInfo />,
  },
  {
    name: "Test Launch Detail",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/test-groups/:group_id/launch-details/:launch_id`,
    component: <TestLaunchDetailWithProjectInfo />,
  },
  {
    name: "Test Launch Detail From Test Case",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/test-cases/launch-details/:launch_id`,
    component: <TestLaunchDetailWithProjectInfo isTestCase />,
  },  
  {
    name: "Apps",
    path: DEFAULT_ROUTES.APPS.slice(1),
    component: 
    <RestrictedRoute allowRoles={[RoleEnum.SUPER_ADMIN.name]}>
    <IntegrationApp />
    </RestrictedRoute>
    ,
  },
  {
    name: "User Apps",
    path: `${DEFAULT_ROUTES.PROJECT.slice(1)}/:project_id/${DEFAULT_ROUTES.USER_APPS.slice(1)}`,
    component: <UserIntegrationAppWithProjectInfo />,
  },
];

function Home() {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const activePage = useSelector((state) => state.navigation.activePage);
  const { user } = useSelector((state) => state.auth || {});
  const dispatch = useDispatch();


  useEffect(()=>{
    if(user){
      setUserPreferences();
    }
  }, []);

  async function setUserPreferences() {
    const response = await fetchUserPreferences();

    if (response.status === STATUS.ERROR) {
      console.error('Failed to fetch user preferences:', response.error);
      return;
    }
    
    const userPreferences = response.data || [];
    let projectListPageView = 'list';
    let tUserPreferences = {};
    
    userPreferences.forEach(preference => {
      if(preference.view_key === 'projectList' ){
        projectListPageView = preference?.preferences?.projectPageView || 'list';
      }
      let tPreferences = {};
      for(let key in viewColumnMap[preference.view_key]){
        tPreferences[key] = preference?.preferences?.columnVisible.includes(key);
      }
      tUserPreferences[`${viewMap[preference.view_key]}`] = {
        columnVisible: tPreferences
      };
    });
    dispatch(updateUserPreferences(tUserPreferences));
    dispatch(updatePageList(projectListPageView));
  }
  // Handle Sidebar Toggle
  const handleSidebarToggle = (expanded) => {
    setIsSidebarExpanded(expanded);
  };
  
  const loading = useSelector((state) => state.common.loading);

  return (
    loading ? 
    <GhostLoader root={true}/> 
    :
      <Box
        sx={{
          display: "flex",
          boxSizing: "border-box",
          height: '100vh',
          width: '100%',
          overflow: "hidden", // Prevent body overflow
        }}
      >
        {/* Route Watcher for URL-to-Redux sync */}
        <RouteWatcher />
        
        {/* Sidebar */}
        <Sidebar onToggle={handleSidebarToggle} />

        {/* Main Content Area */}
        <Box
          sx={{
            boxSizing: "border-box",
            flex: 1, // Take remaining space after sidebar
            display: "flex",
            flexDirection: "column",
            minWidth: 0, // Allow shrinking below content size
            overflow: "hidden", // Prevent overflow at this level
          }}
        >
          {/* Navbar */}
          <Navbar />
          {/* Trial credits banner (Script Creator usage / upgrade prompt when expired) */}
          <TrialCreditsBanner />
          {/* Page Content */}
          <Box
            sx={{
              flex: 1, // Take remaining space after navbar
              overflow: "auto", // Enable scrolling when content exceeds space
              minHeight: 0, // Allow flex item to shrink below content size
            }}
          >
            <Routes>
              <Route
                path="/"
                element={
                  <Navigate
                    to={`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`}
                  />
                }
              />
              {routesData.map((route, index) => (
                <Route key={index} path={route.path} element={route.component} />
              ))}
              <Route path="*" element={<NotFoundContent />} />
            </Routes>
          </Box>
        </Box>
    </Box>
  );
}

export default Home;
